var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "lockout-timer-wrap"
  }, [_vm.remainingSeconds ? _c('div', [_c('span', {
    staticClass: "lockout-message"
  }, [_c('i', {
    staticClass: "fa fa-lock me-1 lock-icon"
  }), _vm._v(" Locked out. Please wait "), _c('span', {
    staticClass: "lockout-timer"
  }, [_vm._v(_vm._s(_vm.formattedTime))]), _vm._v(". ")])]) : _vm._e()]), _vm.remainingSeconds ? _c('div', [_c('div', {
    staticClass: "progress",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "progress-bar bg-warning",
    style: {
      width: _vm.remainingPercentage + '%'
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.remainingSeconds,
      "aria-valuemin": "0",
      "aria-valuemax": _vm.lockoutSeconds
    }
  })])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }